import React, { useContext } from 'react'
import { DesignContext } from 'contexts/DesignContext'
import { useFormikContext } from 'formik'
import { getFieldName } from 'designer/component/action/Data'
import FavoriteTable from 'designer/component/element/FavoriteTable'

const TableControl = (props) => {
  const designContext = useContext(DesignContext)
  const { jsonForm, widgetName } = designContext
  const { uischema, config } = props
  const formikContext = useFormikContext()
  const { errors } = formikContext

  const fieldName = getFieldName(uischema.name, { config, widgetName })
  const fieldKey = getFieldName(uischema.key, { config, widgetName })
  const formData = jsonForm.formData
  const data = formData

  return (
    <FavoriteTable
      fieldName={fieldName}
      fieldKey={fieldKey}
      config={config}
      title={'Favorite Table'}
      uischema={uischema}
      data={data}
      formData={formData}
      errors={errors}
    />
  )
}

export default TableControl
